<svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="5.375" y="1" width="16.375" height="26" rx="3.75" stroke="currentColor" stroke-width="1.5"/>
<path d="M8.75 8.375C8.75 6.16586 10.5409 4.375 12.75 4.375H14.375C16.5841 4.375 18.375 6.16586 18.375 8.375V13.125H8.75V8.375Z" stroke="currentColor" stroke-width="1.5"/>
</svg>
